import { ItemSection } from "@src/components/tabs/itemSection"
import React from "react"
import * as styles from "./judge.module.scss"
import award1Img from "@images/gamesPage/42aa.png"
import award2Img from "@images/gamesPage/43aa.png"

const Judge = () => {
  return (
    <>
      <ItemSection all="基本规则">
        <p>
          5月13日～6月2日期间，所有已注册机核网账号的玩家在下载试玩游戏后均可进行投票（给游戏点赞），每位玩家不限制投票数量，「线上试玩&评选会」结束后，分别获得“玩家投票”和“开发者互投”票数最高的2款游戏将获得一些小奖品。
        </p>
      </ItemSection>

      <ItemSection all="玩家们试玩游戏后的投票标准">
        <dl className={styles.rule}>
          <dt>
            <span className="tag">喜爱程度:</span>
          </dt>
          <dd>
            最优先的是你对此游戏的喜爱程度，如果你真的非常非常喜欢这款游戏，请大力投票吧；{" "}
          </dd>
          <dt>
            <span className="tag">符合主题:</span>
          </dt>
          <dd>
            与本次开发主题“Take me somewhere nice / 一起漫游”的切合主题程度；
          </dd>
          <dt>
            <span className="tag">创新:</span>
          </dt>
          <dd>玩法、故事、概念、表现手法等，只要有任何一种出乎意料；</dd>
          <dt>
            <span className="tag">表现力:</span>
          </dt>
          <dd>从美术、音乐、动效等是否适合此游戏，并让你觉得非常惊艳；</dd>
        </dl>
      </ItemSection>

      <ItemSection all="奖项奖励">
        <div className={styles.awardImgs}>
          <div>
            <img src={award1Img} alt="award" />
          </div>
          <div>
            <img src={award2Img} alt="award" />
          </div>
        </div>
        <p>
          玩家投票 & 开发者互评 Top1:
          <br /> - 获得机核App BOOOM奖项专属徽章
          <br /> - 《核推》视频推荐
          <br /> - 机核网相关节目推荐及推广资源
          <br /> - 若后续持续开发，可提供免费行业咨询及帮助
        </p>
        <p>
          玩家投票 & 开发者互评 Top2:
          <br /> - 获得机核App BOOOM奖项专属徽章
          <br />- 《核推》视频推荐
          <br />- 若后续持续开发，可提供免费行业咨询及帮助
        </p>
        <p>*若两个奖项获奖团队相同，则“最受玩家欢迎奖”名额向下顺延</p>
      </ItemSection>
    </>
  )
}

export default Judge
